import { useTranslation } from 'next-i18next';

import { alertDialog } from '@/ui_v3';

import { validateImage, type ValidateImageParams } from '../utils/file';

export const useValidateImage = (): ((
  params: ValidateImageParams,
) => Promise<boolean>) => {
  const { t } = useTranslation(['build', 'common']);

  return async (params: ValidateImageParams) => {
    const result = await validateImage(params);
    const { validation } = params;

    if (!result.isValid) {
      if (result.type === 'count') {
        alertDialog.open({
          header: {
            title: t('build.imageUpload.exceedAlertTitle'),
          },
          body: t('build.imageUpload.exceedAlertDescription'),
          confirmText: t('common:common.alertDialog.confirmText'),
        });
        return false;
      } else if (result.type == 'size') {
        alertDialog.open({
          header: {
            title: t('build:build.imageUpload.limitSize', {
              size: validation.mbSize + 'MB',
            }),
          },
          confirmText: t('common:common.alertDialog.confirmText'),
        });
        return false;
      } else if (result.type === 'extension') {
        alertDialog.open({
          header: {
            title: t('build:build.imageUpload.confirmExtension'),
          },
          body: t('build:build.imageUpload.limitExtension', {
            extension: validation.extensions.join(', '),
          }),
          confirmText: t('common:common.alertDialog.confirmText'),
        });
        return false;
      } else if (result.type === 'dimension') {
        alertDialog.open({
          header: {
            title: t('build:build.imageUpload.dimensionExceed'),
          },
          body: t('build:build.imageUpload.limitDimension', {
            dimension: '2048',
          }),
          confirmText: t('common:common.alertDialog.confirmText'),
        });
        return false;
      }
    }

    return true;
  };
};
